<template>
  <div :class="{backColorB: bCb}" id="postilBox" v-show="isAddPostil_">
    <div class="addBox">
      <i @click="addInsert"></i>
    </div>
    <!-- <div class="updateBox" v-show="isUpdatePostil_">
      <i @click="updateInsert"></i>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "postil",
  // props: ["isAddPostil_", "isUpdatePostil_"],
  props: {
    isAddPostil: {
      type: Boolean,
      required: true,
    },
    isUpdatePostil: {
      type: Boolean,
      required: true,
    },
    bCb: {
      type: Boolean,
    }
  },
  data () {
    return {
    };
  },
  components: {},
  computed: {
    isAddPostil_: function () {
      return this.isAddPostil;
    },
    isUpdatePostil_: function () {
      return this.isUpdatePostil;
    }
  },
  methods: {
    addInsert () {
      this.$emit("setIsSeekBox", 4)
    },
    updateInsert () {
      this.$emit("setIsSeekBox", 5)
    }
  },
};
</script>
<style lang="less" scoped>
.backColorB {
  .updateBox {
    i {
      background: url("~@/assets/imgs/editor/yj_ckbz_normal.png") no-repeat !important;
    }
  }
  .addBox {
    i {
      background: url("~@/assets/imgs/editor/yj_tjbz_normal.png") no-repeat !important;
    }
  }
}
#postilBox {
  height: 30px;
  width: 30px;
  position: absolute;
  right: 5px;
  // margin-top: 20px;
  i {
    width: 18px;
    height: 18px;
    display: inline-block;
    cursor: pointer;
  }
  div {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .updateBox {
    i {
      background: url("~@/assets/imgs/editor/ckbz_normal.png") no-repeat;
    }
    i:active {
      background: url("~@/assets/imgs/editor/ckbz_press.png") no-repeat;
    }
  }
  .addBox {
    i {
      background: url("~@/assets/imgs/editor/tjbz_normal.png") no-repeat;
    }
    i:active {
      background: url("~@/assets/imgs/editor/tjbz_press.png") no-repeat;
    }
  }
}
</style>
